import vm from '~/main'
const web = vm.localStorage.translations
const webChatTranslations = web.pages.chat.all

const contextItems = ({ chatItem }) => {
  const userIsGroupAdmin = () => chatItem.currentUser && chatItem.currentUser.isAdmin
  // console.log('chatItem', chatItem)
  return chatItem.isPlug || !chatItem.actionEnabled
    ? []
    : [
        {
          if: true,
          title:
            chatItem.currentUser && chatItem.currentUser.isNotificationsEnabled
              ? webChatTranslations.notifications_off
              : webChatTranslations.notifications_on,
          icon: 'pages-settings-push_notifications',
          click: () => vm.$store.dispatch('chat/CHANGE_chatNotification', { chatId: chatItem.id }),
        },
        {
          if:
            chatItem &&
            chatItem.messages.length &&
            (chatItem.type === 'GROUP' ? userIsGroupAdmin() : true),
          title: webChatTranslations.clear_history,
          icon: 'chat-clear',
          click: () => vm.$store.dispatch('chat/messages/DELETE_chatMessagesClear', { chatId: chatItem.id }),
        },
      ]
}

export default contextItems
